import { WprBaseViewInfo } from '../../wpr-framework/view/WprBaseViewInfo';
import { VIEW_DEFINE_JSON, ROOT_TITLE } from '../../common/viewDefine';
import { postUtagView } from '../../../public/utag';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';

// WRQ-2990_旅行保険　直扱販売のための対応 START
/**
 * ブラックリストエラー表示ビュー情報
 */
export class BlackListErrorComponentView extends WprBaseViewInfo {
	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 		= null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('b_error');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
	}

	/**
     * アクション登録
     */
	public onRegisterAction(): void {
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		document.title = VIEW_DEFINE_JSON[11].title+ROOT_TITLE;
		this.onUtagView();
		this.refreshView();
	}

	/**
	 * ドキュメントタイトル取得
	 * @returns ドキュメントタイトル
	 */
	public getDocumentTitle() : string {
		if (this.name !== '') {
			const viewDifine = VIEW_DEFINE_JSON.find((view) => {
				return (view.virtualPage === '/'+this.name);
			});
			if (viewDifine !== null)
			return viewDifine.title+ROOT_TITLE;
		}
		return null;
	}
	// --------------------------------------------------------------------------
	
	// private メソッド  ---------------------------------------------------------------
	/**
	 * Tealium Utag View　処理
	 */
	private onUtagView(): void {
		try {
			postUtagView(VIEW_DEFINE_JSON[11], this.m_ProductCode);
		} catch (e) {
			console.log('utag_view post error');
		}
	}
	// --------------------------------------------------------------------------
}
// WRQ-2990_旅行保険　直扱販売のための対応 END